/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-animals
 * Generated: 2026-06-06T03:14:40.881Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 57 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const animalsWords = [
    {
        "word": "MOOSE"
    },
    {
        "word": "BISON"
    },
    {
        "word": "EAGLE"
    },
    {
        "word": "ROBIN"
    },
    {
        "word": "BEAVER"
    },
    {
        "word": "OTTER"
    },
    {
        "word": "DEER"
    },
    {
        "word": "HARE"
    },
    {
        "word": "BADGER"
    },
    {
        "word": "RACCOON"
    },
    {
        "word": "SQUIRREL"
    },
    {
        "word": "HAWK"
    },
    {
        "word": "FALCON"
    },
    {
        "word": "HERON"
    },
    {
        "word": "SWAN"
    },
    {
        "word": "GOOSE"
    },
    {
        "word": "DUCK"
    },
    {
        "word": "SPARROW"
    },
    {
        "word": "FINCH"
    },
    {
        "word": "HORSE"
    },
    {
        "word": "SHEEP"
    },
    {
        "word": "GOAT"
    },
    {
        "word": "CHICKEN"
    },
    {
        "word": "ROOSTER"
    },
    {
        "word": "DONKEY"
    },
    {
        "word": "MULE"
    },
    {
        "word": "LAMB"
    },
    {
        "word": "CALF"
    },
    {
        "word": "FOAL"
    },
    {
        "word": "PARROT"
    },
    {
        "word": "CANARY"
    },
    {
        "word": "HAMSTER"
    },
    {
        "word": "RABBIT"
    },
    {
        "word": "FERRET"
    },
    {
        "word": "GERBIL"
    },
    {
        "word": "FISH"
    },
    {
        "word": "KITTEN"
    },
    {
        "word": "PUPPY"
    },
    {
        "word": "ELEPHANT"
    },
    {
        "word": "TIGER"
    },
    {
        "word": "LION"
    },
    {
        "word": "GIRAFFE"
    },
    {
        "word": "ZEBRA"
    },
    {
        "word": "PANDA"
    },
    {
        "word": "KOALA"
    },
    {
        "word": "KANGAROO"
    },
    {
        "word": "MONKEY"
    },
    {
        "word": "LEOPARD"
    },
    {
        "word": "JAGUAR"
    },
    {
        "word": "GORILLA"
    },
    {
        "word": "CAMEL"
    },
    {
        "word": "OSTRICH"
    },
    {
        "word": "PENGUIN"
    },
    {
        "word": "DOLPHIN"
    },
    {
        "word": "WHALE"
    },
    {
        "word": "SHARK"
    },
    {
        "word": "SEAL"
    }
];
//# sourceMappingURL=animals.js.map